interface NumberInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  required?: boolean;
  min?: number;
  max?: number;
}

export const NumberInput = ({ value, onChange, placeholder, error, required, min, max }: NumberInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      e.currentTarget.blur();
    }
  };

  return (
    <div className="questionnaire-question-content">
      <div className="input-field-number-container">
        {/* Background container */}
        <div className="input-background" />
        <input
          type="number"
          inputMode="numeric"
          value={value}
          step="any"
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className={`input-field-number ${error ? 'input-field-error' : ''}`}
        />
      </div>
    </div>
  );
};
